import { render, staticRenderFns } from "./tourGuide.vue?vue&type=template&id=164a8ba7&scoped=true"
import script from "./tourGuide.vue?vue&type=script&lang=js"
export * from "./tourGuide.vue?vue&type=script&lang=js"
import style0 from "./tourGuide.vue?vue&type=style&index=0&id=164a8ba7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a8ba7",
  null
  
)

export default component.exports